import { useEffect } from "react";

// His `wake`: keep the screen on. The browser drops the lock whenever the page is hidden (another tab,
// the native camera), so it is forgotten on "release" and taken again when the page comes back — while
// `again` still holds. `on` takes it. A job's lock is never released on a pause or a finish, as his
// `wake`; the photo station's is, when the tablet leaves the station (his `stationOn(false)`).
export function useWakeLock(on: boolean, again: boolean, releaseAtEnd = false) {
  useEffect(() => {
    if (!("wakeLock" in navigator)) return;
    let lock: WakeLockSentinel | null = null;
    let gone = false;
    const take = () => {
      if (lock || gone) return;
      navigator.wakeLock.request("screen")
        .then((l) => {
          if (gone) { void l.release(); return; }
          lock = l;
          l.addEventListener("release", () => { if (lock === l) lock = null; });
        })
        .catch(() => { lock = null; });
    };
    const back = () => { if (document.visibilityState === "visible" && again) take(); };
    if (on) take();
    document.addEventListener("visibilitychange", back);
    return () => {
      gone = true;
      document.removeEventListener("visibilitychange", back);
      if (releaseAtEnd) void lock?.release().catch(() => {});
    };
  }, [on, again, releaseAtEnd]);
}
